export const iconFontAwesomeCommunicationSquarePhone = (
	<i className="fa-solid fa-square-phone"></i>
);
